module.exports = __webpack_public_path__ + "static/media/info-icon.97e280d0.png";